if(typeof BSS_B2B != undefined) {
  if(window.location.pathname.includes("/products")) {
    setTimeout(() =>{
      const productForm = document.querySelector(".product-info.product-info--sticky");
      const formID = productForm.getAttribute("bss-b2b-product-form-id");
      if(formID) {
        const stickyBar = document.querySelector(".sticky-atc-panel");
        stickyBar.setAttribute("bss-b2b-product-form-id", formID);
        stickyBar.setAttribute("bss-b2b-product-form", "main")
        BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', {productForm});
      }
    }, 3000)
  }

//   function initQuickView() {
//     let quickViewBtn = document.querySelectorAll(".js-quick-add");

//     if (quickViewBtn.length) {
//         quickViewBtn.forEach(btn => {
//             btn.onclick = function () {
//                 setTimeout(function () {
//                     const modalQuickview = document.querySelector(".quick-add__product-details");

//                     if (modalQuickview) {
//                         modalQuickview.removeAttribute("bss-b2b-product-form");
//                         modalQuickview.removeAttribute("bss-b2b-observer-id");
//                         modalQuickview.removeAttribute("bss-b2b-product-form-id");
//                     }
//                     document.dispatchEvent(new Event("bss_b2b:QuickviewLoaded"));
//                 }, 1500);
//             };
//         });
//     }
//   }

// setTimeout(() => {
//     initQuickView();

//     const showMore = document.querySelector(".js-pagination-load-more");
//     if (showMore) {
//         showMore.addEventListener("click", () => {
//             setTimeout(() => {
//                 initQuickView(); 
//             }, 1500);
//         });
//     }
// }, 3000);

  setTimeout(() =>{
    const targetMinicart = document.querySelector("cart-drawer");
    if (targetMinicart) {
        const mutationObserver = new MutationObserver(async (recordList, observe) => {
          await BSS_B2B.storage.productStorage.load(); 
          BSS_B2B.cp?.utils?.init();
          BSS_B2B.td?.utils?.init();
          BSS_B2B.observer.productSubject.notifyObserver('ProductMutate', 'ProductPriceMutate');
      });
      mutationObserver.observe(targetMinicart, { childList: true, subtree: true });
    }
  }, 1000)
}

document.addEventListener("DOMContentLoaded", e => {
  handleTEBox();
})

function handleTEBox(){
      const translations = BSS_B2B.te.teTranslations;
    const successMessages = [
      document.querySelector('.bss-b2b-translation-vat-form_success_message'),
      document.querySelector('.bss-b2b-translation-vat-form_success_message_uk'),
      document.querySelector('.bss-b2b-translation-vat-form_success_message_abn'),
      document.querySelector('.bss-b2b-translation-vat-form_success_message_gst'),
      document.querySelector('.bss-b2b-translation-vat-form_success_message_us_ein')
    ];

    successMessages.forEach((msg, index) => {
      if (msg) {
        switch (index) {
          case 0:
            msg.innerText = translations.form_success_message || '';
            break;
          case 1:
            msg.innerText = translations.form_success_message_uk || '';
            break;
          case 2:
            msg.innerText = translations.form_success_message_abn || '';
            break;
          case 3:
            msg.innerText = translations.form_success_message_gst || '';
            break;
          case 4:
            msg.innerText = translations.form_success_message_us_ein || '';
            break;
        }
      }
    });

    const errorMessages = [
      document.querySelector('.bss-b2b-translation-vat-form_error_message'),
      document.querySelector('.bss-b2b-translation-vat-form_error_message_uk'),
      document.querySelector('.bss-b2b-translation-vat-form_error_message_abn'),
      document.querySelector('.bss-b2b-translation-vat-form_error_message_gst'),
      document.querySelector('.bss-b2b-translation-vat-form_error_message_us_ein'),
      document.querySelector('.bss-b2b-translation-vat-form_validate_country_code_message')
    ];

    errorMessages.forEach((msg, index) => {
      if (msg) {
        switch (index) {
          case 0:
            msg.innerText = translations.form_error_message || '';
            break;
          case 1:
            msg.innerText = translations.form_error_message_uk || '';
            break;
          case 2:
            msg.innerText = translations.form_error_message_abn || '';
            break;
          case 3:
            msg.innerText = translations.form_error_message_gst || '';
            break;
          case 4:
            msg.innerText = translations.form_error_message_us_ein || '';
            break;
          case 5:
            msg.innerText = translations.form_validate_country_code_message || '';
            break;
        }
      }
    });
}

document.addEventListener('bss_b2b:CustomCartUpdate', ()=> {
  if(BSS_B2B){
    BSS_B2B?.observer?.cartSubject?.listenCartCheckout?.();
    handleTEBox();
  }
})